import { buildCSV } from "../../utils/buildCSV";

/* small helper to read numbers safely */
function toNum(v) {
  if (v === null || v === undefined || v === "") return null;
  const n =
    typeof v === "number"
      ? v
      : parseFloat(String(v).replace(/[^0-9.,-]/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

export const Go2Zero = {
  type: "Go2Zero",
  detect: (wb, file) =>
    wb.SheetNames.includes("Result CO2-Footprint") ||
    file.name.toLowerCase().includes("go2zero"),

  parse: (wb) => {
    const ws = wb.Sheets["Result CO2-Footprint"];
    const read = (addr) => ws[addr]?.v ?? null;

    return {
      type: "Go2Zero",
      referenzjahr: toNum(read("G7")),
      gesamt_co2: toNum(read("G9")),
      spezifisch_co2: toNum(read("G10")),
      emissionen: {
        strom: { wert_tonnen: toNum(read("E14")), scope: 2 },
        heizung: { wert_tonnen: toNum(read("E15")), scope: 1 },
        fuhrpark: { wert_tonnen: toNum(read("E16")), scope: 1 },
      },
      verbrauch: {
        strom_kwh_m2: toNum(read("E45")),
        heizung_kwh_m2: toNum(read("E46")),
      },
    };
  },

  missingDefaults: {
    mengeStrom: "",
    abfallTonnen: "",
    verbrauchsmaterialLack: "",
    verbrauchsmaterialAllg: "",
    verbrauchsmaterialErsatzteile: "",
  },

  mergeMissing: (base, form, toNum) => ({
    ...base,
    mengeStrom: toNum(form.mengeStrom),
    abfall: { menge_tonnen: toNum(form.abfallTonnen) },
    verbrauchsmaterialien: {
      lack_chf: toNum(form.verbrauchsmaterialLack),
      materialien_chf: toNum(form.verbrauchsmaterialAllg),
      ersatzteile_chf: toNum(form.verbrauchsmaterialErsatzteile),
    },
  }),

  buildCSV,
};
